
const SubmenuActualidad = () => {
	return (
		<svg
			viewBox="0 0 1929 360"
			className="absolute z-1"
			style={{ zIndex: 1 }}>
			<defs>
				<style>
					{
						'.a-submenu-p{fill:none;}.b-submenu-p{fill:#001f5f;}.c-submenu-p{clip-path:url(#a-submenu-p);}.d-submenu-p,.h-submenu-p,.k-submenu-p{fill:#fff;}.e-submenu-p{fill:#e7002a;}.f-submenu-p{fill:url(#b-submenu-p);}.g-submenu-p,.j-submenu-p{opacity:0.8;fill:url(#e-submenu-p);}.h-submenu-p{font-size:42px;}.h-submenu-p,.k-submenu-p{font-family:"Kiona-Bold";font-weight:700;}.i-submenu-p{fill:url(#h-submenu-p);}.j-submenu-p,.m-submenu-p{mix-blend-mode:multiply;isolation:isolate;}.k-submenu-p{font-size:24px;}.l-submenu-p{fill:url(#j-submenu-p);}.m-submenu-p{filter:url(#f-submenu-p);}.n-submenu-p{filter:url(#c-submenu-p);}'
					}
				</style>
				<clipPath id="a-submenu-p">
					<rect
						className="a-submenu-p"
						width={1427.387}
						height={206.155}
					/>
				</clipPath>
				<pattern
					id="b-submenu-p"
					preserveAspectRatio="xMidYMid slice"
					width="100%"
					height="100%"
					viewBox="0 0 3745 2499">
					<image
						width={3745}
						height={2499}
						xlinkHref="/images/navbar/act-3.jpg"
					/>
				</pattern>
				<filter
					id="c-submenu-p"
					x={0}
					y={0}
					width={597.611}
					height={349.159}
					filterUnits="userSpaceOnUse">
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} result="d" />
					<feFlood floodOpacity={0.502} />
					<feComposite operator="in" in2="d" />
					<feComposite in="SourceGraphic" />
				</filter>
				<linearGradient
					id="e-submenu-p"
					x1={0.5}
					x2={0.5}
					y2={1}
					gradientUnits="objectBoundingBox">
					<stop offset={0} stopColor="#001f5f" stopOpacity={0} />
					<stop offset={1} stopColor="#001f5f" />
				</linearGradient>
				<filter
					id="f-submenu-p"
					x={0}
					y={0}
					width={597.611}
					height={349.159}
					filterUnits="userSpaceOnUse">
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} result="g" />
					<feFlood floodOpacity={0.502} />
					<feComposite operator="in" in2="g" />
					<feComposite in="SourceGraphic" />
				</filter>
				<pattern
					id="h-submenu-p"
					width={1}
					height={1}
					viewBox="0 44.586 674.352 206.606">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={674.352}
						height={449.568}
						xlinkHref="/images/navbar/act-2.jpg"
					/>
				</pattern>
				<pattern
					id="j-submenu-p"
					width={1}
					height={1}
					viewBox="0 74.419 674.352 206.606">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={674.352}
						height={341.444}
						xlinkHref="public/images/navbar/act-1.jpg"
					/>
				</pattern>
			</defs>
			<g transform="translate(0 -105)">
				<g transform="translate(492.612 -22.409)">
					<rect
						className="b-submenu-p"
						width={1427.387}
						height={206.155}
						transform="translate(0 126.409)"
					/>
					<g transform="translate(0 126.409)">
						<g className="c-submenu-p">
							<path
								className="d-submenu-p"
								d="M1189.053,402.13l-.541-.21,41.367-92.276a55.308,55.308,0,0,1,21.556-24.336,61.508,61.508,0,0,1,32.454-9.135h184.873v.544H1283.888c-23.457,0-44.444,13.007-53.468,33.136Z"
								transform="translate(-5.245 -137.554)"
							/>
							<path
								className="d-submenu-p"
								d="M369.429,0l.638.247L321.252,109.14a65.276,65.276,0,0,1-25.436,28.719,72.593,72.593,0,0,1-38.3,10.779H39.353V148H257.516c27.681,0,52.448-15.349,63.1-39.1Z"
								transform="translate(-0.174 -117.002)"
							/>
							<path
								className="e-submenu-p"
								d="M1442.394,155.049,1386.479,279.8c-9.024,20.13-30.01,33.136-53.468,33.136h-28.562v0H1169.46A61.52,61.52,0,0,0,1137,322.063a55.312,55.312,0,0,0-21.555,24.336L581.086,471.147l.541.21L1115.99,346.61c9.025-20.13,30.012-33.136,53.47-33.136h28.562v0h134.99a61.522,61.522,0,0,0,32.455-9.135,55.319,55.319,0,0,0,21.556-24.336l55.913-124.748Z"
								transform="translate(-2.564 -128.54)"
							/>
						</g>
					</g>
				</g>
				<path
					className="b-submenu-p"
					d="M367.709,339.246H0V0H586.714l-62.14,206.671a173.939,173.939,0,0,1-15.633,36.562c-36.385,63.36-89.124,96.013-141.232,96.013"
					transform="translate(0 104)"
				/>
				<g
					className="n-submenu-p"
					transform="matrix(1, 0, 0, 1, -9, 98)">
					<path
						className="f-submenu-p"
						d="M366,457.568H0V126.409H579.611L519,328.153a169.849,169.849,0,0,1-15.248,35.69C468.267,425.694,416.828,457.568,366,457.568"
						transform="translate(9 -120.41)"
					/>
				</g>
				<g
					className="m-submenu-p"
					transform="matrix(1, 0, 0, 1, -9, 98)">
					<path
						className="g-submenu-p"
						d="M366,457.568H0V126.409H579.611L519,328.153a169.849,169.849,0,0,1-15.248,35.69C468.267,425.694,416.828,457.568,366,457.568"
						transform="translate(9 -120.41)"
					/>
				</g>
				<text className="h-submenu-p" transform="translate(281 396)">
					<tspan x={-128.268} y={0}>
						{'aCTUALIDAD'}
					</tspan>
				</text>
				<path
					className="i-submenu-p"
					d="M66.392,0,0,206.606H607.96L674.352,0Z"
					transform="translate(525 103.094)"
				/>
				<path
					className="j-submenu-p"
					d="M66.392,0,0,206.606H607.96L674.352,0Z"
					transform="translate(525 103.094)"
				/>
				<text className="k-submenu-p" transform="translate(712 265)">
					<tspan x={78.168} y={24}>
						{'nOTICIAS'}
					</tspan>
				</text>
				<path
					className="l-submenu-p"
					d="M692.66,0,626.268,206.606h607.96L1300.62,0Z"
					transform="translate(511.48 103.094)"
				/>
				<path
					className="j-submenu-p"
					d="M692.66,0,626.268,206.606h607.96L1300.62,0Z"
					transform="translate(511.48 103.094)"
				/>
				<text className="k-submenu-p" transform="translate(1316 265)">
					<tspan x={79.776} y={24}>
						{'eVENTOS'}
					</tspan>
				</text>
			</g>
		</svg>
	)
}

export default SubmenuActualidad
